export default __webpack_public_path__ + "static/media/netschool.4d305cce.png";